import {STORAGE} from "../../storage";
import {dispatchAction} from "../../state/dispatchAction";
import {setToken} from "../../../reducers/configSlice";

export const handleRefreshToken = async (token) => {
    await STORAGE.set("token", token)
    dispatchAction(setToken(token))
};